<template>
  <div class="le-ruler-zoom">
    <div class="le-zoom-item le-zoom-full">
      <div class="le-zoom-full-btn" @click="handleFullScreen">
        <svg class="le-zoom-icon le-full-icon" viewBox="0 0 24 24">
          <path fill="#333" d="m6.001,14.132a1,1 0 0 1 1,1l0,1.828l2.889,-2.889a1,1 0 1 1 1.414,1.414l-2.89,2.89l1.83,0a1,1 0 1 1 0,2l-4.244,0a1,1 0 0 1 -1,-1l0,-4.243a1,1 0 0 1 1,-1l0.001,0zm7.131,-7.132a1,1 0 0 0 1,1l1.829,0l-2.89,2.889a1,1 0 0 0 1.415,1.414l2.889,-2.889l0,1.828a1,1 0 1 0 2,0l0,-4.242a1,1 0 0 0 -1,-1l-4.243,0a1,1 0 0 0 -1,1z" />
        </svg>
      </div>
    </div>
    <div class="le-zoom-item le-zoom-sub" :class="{'is-disabled' : subDisabled}" @click.stop="handleZoomSubEvent">
      <svg class="le-zoom-icon le-sub-icon" viewBox="0 0 24 24">
        <path d="M6 12.5H17" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <div class="le-zoom-number-item">
      <el-dropdown class="le-zoom-dropdown" placement="top" @command="handleZoomCommand">
        <el-button class="le-zoom-btn">{{ zoomScale }}%</el-button>

        <el-dropdown-menu slot="dropdown" class="le-zoom-dropdown-menu">
          <el-dropdown-item v-for="item in zoomList" :key="item" class="zoom-item" :command="item">{{ item }}%</el-dropdown-item>
          <el-dropdown-item class="zoom-item" :command="-1">适应屏幕</el-dropdown-item>
          <el-dropdown-item class="zoom-item" :command="-2">实际大小</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="le-zoom-item le-zoom-add" :class="{'is-disabled' : addDisabled}" @click.stop="handleZoomAddEvent">
      <svg class="le-zoom-icon le-add-icon" viewBox="0 0 24 24">
        <path d="M6 12.5H17M11.5 7V18" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
  </div>
</template>

<script>
import {childMixins, commonMixins} from '../../scripts/mixins';
import {eventNameConst} from '../../scripts/conf';
import {
  handleHeaderBtnFullScreenEvent,
  handleScaleAutoZoom,
  handleScaleRealZoom,
  handleScaleZoomInEvent,
  handleScaleZoomNumber,
  handleScaleZoomOutEvent
} from '../../scripts/core/logic/logic';

export default {
  name: 'LeTpZoom',
  mixins: [childMixins, commonMixins],
  data() {
    return {
      currentScale: 1,
      zoomList: [10, 25, 50, 75, 100, 150, 200, 300]
    };
  },
  computed: {
    zoomScale() {
      return Math.trunc(this.currentScale * 100);
    },
    subDisabled() {
      return this.zoomScale === 10;
    },
    addDisabled() {
      return this.zoomScale === 300;
    }
  },
  created() {
    this.$nextTick(() => {
      this.initWheelZoomEvent();
    });
  },
  methods: {
    handleFullScreen() {
      handleHeaderBtnFullScreenEvent(this);
    },
    handleZoomSubEvent() {
      this.currentScale = handleScaleZoomOutEvent(this);
    },
    handleZoomAddEvent() {
      this.currentScale = handleScaleZoomInEvent(this);
    },
    handleZoomCommand(command) {
      if (command === -1) {
        // 适应屏幕
        this.currentScale = handleScaleAutoZoom(this);
      } else if (command === -2) {
        // 实际大小
        this.currentScale = handleScaleRealZoom(this);
      } else {
        this.currentScale = handleScaleZoomNumber(this, command);
      }
    },
    initWheelZoomEvent() {
      this.getCanvasStage().on(eventNameConst.timingEventName.wheelZoom, () => {
        this.currentScale = this.getCanvasStage().getZoom();
      });

      this.getCanvasStage().on(eventNameConst.timingEventName.viewportChange, () => {
        this.currentScale = this.getCanvasStage().getZoom();
      });
    }
  }
};
</script>

<style scoped lang="scss">
.le-ruler-zoom {
  position: absolute;
  height: 32px;
  bottom: 16px;
  right: 16px;

  border-radius: 4px;
  display: flex;
  flex-direction: row;
  background: rgb(255, 255, 255);
  pointer-events: auto;
  -webkit-box-align: center;
  align-items: center;
  padding: 4px 8px;
  box-shadow: rgba(212, 212, 212, 1) 0 2px 6px;
  //box-shadow: rgba(39, 54, 78, 0.8) 0 2px 6px;
  transition: right 0.2s ease-in-out 0s;
  z-index: 999;

  .le-zoom-item {
    width: 24px;
    height: 24px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(51, 51, 51);
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.2s ease-in-out 0s;
    -webkit-box-pack: center;
    -webkit-box-align: center;
    user-select: none;
    -webkit-user-select: none;

    svg {
      width: 24px;
      height: 24px;
      fill: currentcolor;

      > * {
        fill: currentcolor;
      }
    }

    &.is-disabled {
      cursor: not-allowed;
      color: rgb(204, 204, 204);

      .le-full-icon path {
        color: rgb(204, 204, 204);
      }

      .le-sub-icon path, .le-add-icon path {
        stroke: rgb(204, 204, 204);
      }
    }

    &:not(.is-disabled):hover {
      background-color: rgb(242, 242, 242);
    }
  }

  .le-zoom-full-btn {
    width: 24px;
    height: 24px;
    -webkit-box-align: center;
    align-items: center;
    color: #333;
    position: relative;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    user-select: none;
    -webkit-user-select: none;

    .le-full-icon {
      width: 24px;
      height: 24px;
    }
  }

  .le-zoom-sub {
    margin-left: 8px;
  }

  .le-zoom-btn {
    width: 47px;
    height: 28px;
    background: none;
    padding: 0;
    border: 0;
    outline: 0;
    color: inherit;
    cursor: pointer;
    border-radius: 4px;
    margin: 0 4px;
    text-align: center;
    user-select: none;
    -webkit-user-select: none;

    &:hover {
      background-color: rgb(242, 242, 242);
    }
  }
}

.le-zoom-number-item {
  position: relative;
}

.le-zoom-dropdown {
  position: relative;
}

.le-zoom-dropdown-menu {

  &.el-dropdown-menu {
    padding: 5px;
    background-color: #fff;
    border-radius: 2px;
    user-select: none;
    margin: 0 0 10px 0;
    border: 1px solid #ebeef5;

    .zoom-item {
      min-width: 90px;
      height: 30px;
      line-height: 30px;
      border-radius: 2px;
      cursor: pointer;
      color: #272e34;
      padding: 0 15px;
      text-align: left;
      user-select: none;

      &:hover {
        background-color: rgba(143, 153, 168, 0.15);
        cursor: pointer;
        text-decoration: none;
        color: #272e34;
      }
    }
  }
}
</style>
